module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page partners-page mx-5 mt-5 pt-5"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Get paid to share.")]), _vm._v(" "), _c('div', {
    staticClass: "b-body-text"
  }, [_vm._v("\n                With Repost Request verified artists & brands can pay you to share their albums, videos & products to your followers.\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Basic plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("$100")]), _vm._v(" per repost\n                ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pro plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("10k")]), _vm._v(" per repost\n                ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Plus plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("100k")]), _vm._v(" per repost\n                ")])]), _vm._v(" "), _c('span', [_c('v-btn', {
    staticClass: "white--text mt-4 app-blue",
    attrs: {
      "depressed": "",
      "round": "",
      "to": '/adfree#plans'
    }
  }, [_c('b', [_vm._v("Choose Plan")])])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/images/re_sharebg.svg"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e5a8ba0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/getPaidToShare/index.vue
// module id = 1821
// module chunks = 180